import React from 'react';
import range from 'lodash/range';
import { getLocalizedText } from '@vp-dst/localization-util';

import Uploader from 'components/Uploader';
import TooltipPanel from 'components/TooltipPanel';
import DocumentPageThumbnail from 'components/vistaprintUILibrary/DocumentPageThumbnail';
import Pill from 'components/vistaprintUILibrary/Pill';
import TextArea from 'components/vistaprintUILibrary/TextArea';

import { defaultTextStyle, colors } from 'settings/theme';

import productGroupsWithSize from 'data/productGroupsWithSize';

export default function BriefDetail(props) {
    const {
        altDocId,
        numPages = 0,
        templates,
        note,
        noteOnChange,
        noteErrorMessage,
        size,
        sizeOnChange,
        sizeErrorMessage,
        socialMediaLink,
        socialMediaLinkOnChange,
        documentPagePreviewOnClick,
        preSelectedProductName,
        selectedProductConfigurations,
        selectedProduct,
        removeProductConfigurationOnClick,
        tooltipExpanderOnClick,
        isHolidayUG,
        isReadOnly,
        uploadRefs,
        isEditFromCart,
        isSocialMediaDesign
    } = props;

    const isInTooltipTest = true; //leaving it in, in case we wnat to change exposure/make restricted to some cultures only
    const pages = range(1, numPages + 1);

    const readOnlyStyle = {
        backgroundColor: colors.mist,
        WebkitTextFillColor: colors.carbon,
        opacity: 1,
    };

    //the code below is a hack to work around the fact that that 
    //there's a bug with jquery tooltip that's preventing React onClick from firing, 
    //so we need to put a listener onto the element
    const [tooltipTriggerEl, setTooltipTriggerEl] = React.useState();
    React.useEffect(() => {
        if (tooltipTriggerEl === undefined) {
            return;
        }
        const handleClick = () => tooltipExpanderOnClick();
        tooltipTriggerEl.addEventListener("click", handleClick);
        return () => tooltipTriggerEl.removeEventListener("click", handleClick);
    }, [tooltipTriggerEl]);

    
    return (
        <div>
            {
                isHolidayUG 
                ? (
                    <React.Fragment>
                        <h1
                            style={{
                                fontWeight: 'bold',
                                textAlign: 'center',
                                marginBottom: 15,
                            }}>
                            {getLocalizedText('tell-us-about-your-design-idea-holiday-ug')}
                        </h1>
                        <div
                            style={{
                                ...defaultTextStyle,
                                fontSize: '1.5em',
                                textAlign: 'center',
                                marginBottom: 30,
                            }}
                        >
                            {preSelectedProductName || getLocalizedText('tell-us-about-your-design-idea-holiday-ug-subtitle')}
                        </div>
                    </React.Fragment>
                )
                :
                ( 
                <div
                    style={{
                        ...defaultTextStyle,
                        fontSize: '2em',
                        fontWeight: 'bold',
                        textAlign: 'center',
    
                        marginBottom: 30,
                    }}
                >
                    {getLocalizedText(isSocialMediaDesign ? 'tell-us-about-your-design-idea-social-media' : 'tell-us-about-your-design-idea')}
                </div>)
            }
            {(altDocId) &&
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        overflow: 'auto',

                        marginBottom: 20,
                    }}
                >
                    {pages.map(pageNumber => {
                        return (
                            <div
                                key={`document-preview-page-${pageNumber}`}
                                style={{
                                    height: 200,
                                    padding: 10,

                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                }}
                                onClick={() => { documentPagePreviewOnClick({ altDocId, pageNumber })}}
                            >
                                <DocumentPageThumbnail
                                    altDocId={altDocId}
                                    pageNumber={pageNumber}
                                    height={200}
                                    width={200}
                                    imageHeightPixels={200}
                                    imageWidthPixels={200}
                                    shadow={true}
                                />
                            </div>
                        );
                    })}
                </div>
            }
            {/* template edits has both the altdocid and templates in the url, don't render both */}
            {!altDocId && templates &&
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        overflow: 'auto',
                        marginBottom: 20,
                    }}
                >
                    {templates.map(templateId => {
                        
                            return (
                                <div
                                    key={`document-preview-template-${templateId}`}
                                    style={{
                                        height: 200,
                                        padding: 10,
    
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        cursor: 'pointer',
                                    }}
                                    onClick={() => { documentPagePreviewOnClick({ altDocId, templateId })}}
                                >
                                    <DocumentPageThumbnail
                                        altDocId={altDocId}
                                        templateId={templateId}
                                        height={200}
                                        width={200}
                                        imageHeightPixels={200}
                                        imageWidthPixels={200}
                                        shadow={true}
                                    />
                                </div>
                            );
                        })}
                </div>
            }
            {isInTooltipTest && 
                <div style={{
                        ...defaultTextStyle,
                        marginBottom: 20,
                        fontSize: '14px',
                    }}>
                    {/*SMD-TODO:  Make this a span again, and not inline block */}
                    <div style={{display: "inline-block"}}>{getLocalizedText(isSocialMediaDesign ? 'design-idea-specifics-social-media' : 'please-help-your-designer')}
                        <button className="textbutton textbutton-skin-primary textbutton-round" data-rel="tooltip" 
                            aria-describedby="tooltipContent"
                            ref={setTooltipTriggerEl}
                            style={{marginLeft: 4}}>
                            <span className="textbutton-icon textbutton-icon-info"></span>
                        </button>
                        <aside id="tooltipContent" role="tooltip">
                            <TooltipPanel shownOnSubmit={false}/>
                        </aside>
                    </div> 
                </div>
            }
            <TextArea
                autoResize={true}
                fullWidth={true}
                value={note}
                errorMessage={noteErrorMessage}
                containerStyle={{
                    marginBottom: 20,
                }}
                style={{
                    resize: 'vertical',
                    minHeight: 125,
                    ...(isReadOnly ? readOnlyStyle : {})
                }}
                placeholder={isInTooltipTest ? '' : getLocalizedText(isSocialMediaDesign ? 'design-idea-specifics-social-media' : 'design-idea-specifics')}
                rows="4"
                onChange={noteOnChange}
                disabled={isReadOnly}
            />
            {!isReadOnly && !isEditFromCart && selectedProduct && requiresSizeField(selectedProduct.productGroup) &&
                <TextArea
                    autoResize={false}
                    fullWidth={true}
                    value={size}
                    errorMessage={sizeErrorMessage}
                    containerStyle={{
                        marginBottom: 20,
                    }}
                    placeholder={getLocalizedText('design-size-specifics')}
                    rows="1"
                    onChange={sizeOnChange}
                    disabled={isReadOnly}
                />
            }
            {!isReadOnly && !isEditFromCart && isSocialMediaDesign &&
                <div style={{
                        ...defaultTextStyle,
                        marginBottom: 20,
                        fontSize: '14px',
                    }}>
                    <span>{getLocalizedText('social-media-links')}</span>
                    <TextArea
                        autoResize={false}
                        fullWidth={true}
                        value={socialMediaLink}
                        containerStyle={{
                            marginBottom: 20,
                        }}
                        rows="1"
                        onChange={socialMediaLinkOnChange}
                        disabled={isReadOnly}
                    />
                </div>
            }

            {selectedProductConfigurations.length > 0 &&
                <div>
                    <div
                        style={{
                            ...defaultTextStyle,
                            fontSize: '1.3em',
                            fontWeight: 'bold',
                            marginBottom: 20,
                        }}
                    >
                        {getLocalizedText('your-selected-product-options')}
                    </div>
                    <div
                        style={{
                            marginBottom: 20,
                        }}
                    >
                        {selectedProductConfigurations.map(config => (
                            <Pill
                                key={`product-configuration-${config.id}`}
                                text={`${config.displayName}: ${config.value}`}
                                onClick={() => removeProductConfigurationOnClick(config.id)}
                                style={{
                                    marginRight: 10,
                                    marginBottom: 10,
                                }}
                            />
                        ))}
                    </div>
                </div>
            }
            <Uploader 
                isReadOnly={isReadOnly}
                uploadRefs={uploadRefs}/>
        </div>
    );
}

export function requiresSizeField(productGroup)
{
    return productGroupsWithSize.indexOf(productGroup) !== -1;
}



// WEBPACK FOOTER //
// ./src/components/BriefDetail.js